"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAssociatedWithTask;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _associationKeysForOb;

var associationKeysForObjectType = (_associationKeysForOb = {}, (0, _defineProperty2.default)(_associationKeysForOb, _ObjectTypes.CONTACT, 'contactIds'), (0, _defineProperty2.default)(_associationKeysForOb, _ObjectTypes.COMPANY, 'companyIds'), (0, _defineProperty2.default)(_associationKeysForOb, _ObjectTypes.DEAL, 'dealIds'), (0, _defineProperty2.default)(_associationKeysForOb, _ObjectTypes.TICKET, 'ticketIds'), _associationKeysForOb);

function isAssociatedWithTask(task, objectType, objectId) {
  var parsedObjectId = parseInt(objectId, 10);
  var objectAssociationKey = associationKeysForObjectType[objectType];
  var associationsForType = task.getIn(['associations', objectAssociationKey], (0, _immutable.List)());
  return associationsForType.includes(parsedObjectId);
}

module.exports = exports.default;